export default "__VITE_ASSET__DNuoRYBO__"